import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
// import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Button from '@nubank/nuds-web/components/Button/Button';

// import Section from 'components/structure/Section';
import Block from './components/structure/Block/Block.js';
import Carousel from './components/Carousel/Carousel.js';


class SectionSteps extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (


<Grid
  row
  tag="section"
  alignItems="center"
  spacingHorizontal={{
    xs: "4x",
    md: "8x",
    lg: "12x",
  }}
  spacingVertical={{
    xs: "6x",
    md: "6x",
    lg: "16x",
  }}
  backgroundColor="white.dark"
>
  <Grid
    col="fill"
    offset={{
      xs: 0,
      lg: 1,
    }}
  >
    <Typography variant="heading3" gutterBottom={2.5} gutterTop={2.5}>
      Trilha de desenvolvimento
    </Typography>

    <Grid row alignItems="center">

      <Grid justifyContent="center" col="fill">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Button variant="contained" styleVariant="primary">
            1
          </Button>
        </Box>
        <Typography variant="heading3" textAlign="center" color="primary">
          Onboarding
        </Typography>
        <Typography
          variant="paragraph1"
          gutterBottom={1.5}
          textAlign="center"
          color="black"
        >
          Institucional e funcional
        </Typography>

      </Grid>


      <Grid justifyContent="center" col="fill">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Button variant="contained" styleVariant="primary">
            2
          </Button>
        </Box>
        <Typography variant="heading3" textAlign="center" color="primary">
          Treinamentos
        </Typography>
        <Typography
          variant="paragraph1"
          gutterBottom={1.5}
          textAlign="center"
          color="black"
        >
          Funcionais, diferentes ferramentas e plataformas
        </Typography>

      </Grid>

      <Grid justifyContent="center" col="fill">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Button variant="contained" styleVariant="primary">
            3
          </Button>
        </Box>
        <Typography variant="heading3" textAlign="center" color="primary">
          Acompanhamento
        </Typography>       
        <Typography
          variant="paragraph1"
          gutterBottom={1.5}
          textAlign="center"
          color="black"
        >
          Feedbacks trimestrais
        </Typography>
      </Grid>


      <Grid justifyContent="center" col="fill">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Button variant="contained" styleVariant="primary">
            4
          </Button>
        </Box>
        <Typography variant="heading3" textAlign="center" color="primary">
          Desenvolvimento
        </Typography>
        <Typography
          variant="paragraph1"
          gutterBottom={1.5}
          textAlign="center"
          color="black"
        >
          Habilidades técnicas, funcionais e comportamentais
        </Typography>

      </Grid>

      <Grid justifyContent="center" col="fill">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Button variant="contained" styleVariant="primary">
            5
          </Button>
        </Box>
        <Typography variant="heading3" textAlign="center" color="primary">
          Comunidade Interna
        </Typography>
        <Typography
          variant="paragraph1"
          gutterBottom={1.5}
          textAlign="center"
          color="black"
        >
          Encontro com a comunidade de estágio no Nubank
        </Typography>
        
      </Grid>



    </Grid>

{/*<Box
  tag="section"
  paddingBottom={{ xs: '12x', md: '10x' }}
  alignItems={{
    md: 'flex-end',
    lg: 'center'
  }}
>
  <Box
    paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
    marginTop={{ xs: '8x', md: '12x', lg: '20x' }}
    display={{ lg: 'grid' }}
    gridColumnGap={{ lg: '8x' }}
  >
    <Box
      gridColumn={{ lg: '3 / 11' }}
      marginHorizontal={{ md: 'auto' }}
      justify='center'
      alignItems='center'
    >
      <Typography
        variant="heading4"
        marginHorizontal={{ md: 'auto' }}
        textAlign={{ md: 'left' }}
        gutterBottom={1.5}
      >
        <ol type="1">
          <li><Typography color= 'primary'>1.</Typography> Ter matrícula ativa em um curso superior (bacharelado, licenciatura ou tecnólogo) em universidade brasileira, sem restrição de cursos;</li>
          <li><Typography color= 'primary'>2.</Typography> Previsão de formação entre dez/2025 a jul/2026;</li>
          <li><Typography color= 'primary'>3.</Typography> Inglês a partir do nível Intermediário;</li>
          <li><Typography color= 'primary'>4.</Typography> Disponibilidade para estagiar 30 horas semanais (6h/dia) no Brasil entre Janeiro 2024 e Dezembro 2025;</li>
          <li><Typography color= 'primary'>5.</Typography> Morar no estado de São Paulo com disponibilidade para estagiar seguindo o modelo de trabalho híbrido do Nubank (Nu Way of Working).</li>
        </ol>
      </Typography>
    </Box>
  </Box>
</Box>*/}


{/*    <Typography
      variant="paragraph1"
      marginHorizontal={{ md: "auto" }}
      textAlign={{ md: "left" }}
      gutterBottom={1.5}
    >
      <br />
      Ofertas para as pessoas aprovadas acontecerão no início de Dezembro.
    </Typography>*/}
  </Grid>
</Grid>


          );
  }
}

export default SectionSteps;  